import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@hub/box';
import { Portal } from '@hub/portal';
import { useToken } from '@hub/design-system-base';
import { Overlay } from '@hub/overlay';
import SearchForm from './search-form';
import limitResults from './limit-results';
import useRefsAndCursor from './use-refs-and-cursor';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ROWS_DISPLAY_LIMIT = 15;
const SearchModalAutocomplete = _ref => {
  let {
    placeholder,
    baseContext,
    onClickClose,
    autocompleteWithState,
    isOpen,
    backgroundColor
  } = _ref;
  const {
    autocomplete: baseAutocomplete,
    autocompleteState,
    resetState,
    setNonDebouncedQuery
  } = autocompleteWithState;
  // see comment in ../types.ts for this cast
  const autocomplete = baseAutocomplete;
  const {
    collections,
    query
  } = autocompleteState;
  const refsAndCursor = useRefsAndCursor(query, collections);
  const collectionsToDisplay = limitResults(collections !== null && collections !== void 0 ? collections : [], ROWS_DISPLAY_LIMIT);
  const reinitialiseQuery = () => {
    const {
      query
    } = autocompleteState;
    if (query) {
      autocomplete.setQuery(query);
    }
  };
  const {
    resetCursor
  } = refsAndCursor;
  const {
    0: isFocusOnInput,
    1: setIsFocusOnInput
  } = useState(false);
  useEffect(() => {
    const inputElement = refsAndCursor.autocompleteRefs.getElems().inputElement;
    if (isOpen && inputElement && !isFocusOnInput) {
      inputElement.focus();
      setIsFocusOnInput(true);
    }
  }, [isOpen, refsAndCursor, isFocusOnInput]);

  // On close, reset the cursor to top of search list
  useEffect(() => {
    if (!isOpen && resetCursor) {
      setIsFocusOnInput(false);
      resetCursor();
    }
  }, [isOpen, resetCursor, setIsFocusOnInput]);
  const containerRef = useRef(null);
  const modalZindex = useToken('zIndices', 'modal');
  const renderContext = _objectSpread(_objectSpread({}, baseContext), {}, {
    query: query !== null && query !== void 0 ? query : ''
  });
  return isOpen ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      ref: containerRef,
      sx: {
        position: 'absolute',
        top: 0,
        left: 0
      },
      "data-id": "search-modal-autocomplete_index_SearchModalAutocomplete_Box"
    }), /*#__PURE__*/_jsx(Portal, {
      "data-id": "search-modal-autocomplete_index_SearchModalAutocomplete_Portal",
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flexShrink: 0,
          width: '100%',
          height: ['100vh', '100vh', 'size-11'],
          backgroundColor,
          top: 0,
          left: 0,
          position: 'fixed',
          zIndex: modalZindex
        },
        "data-id": "search-modal-autocomplete_index_SearchModalAutocomplete_Portal_Box",
        children: /*#__PURE__*/_jsx(SearchForm, {
          backgroundColor,
          refsAndCursor,
          onClickClose,
          autocomplete,
          placeholder,
          query,
          resetState,
          collections: collectionsToDisplay,
          context: renderContext,
          reinitialiseQuery,
          setNonDebouncedQuery,
          "data-id": "search-modal-autocomplete_index_SearchModalAutocomplete_Box_SearchForm"
        })
      })
    }), /*#__PURE__*/_jsx(Overlay, {
      isOpen: isOpen,
      trigger: "click",
      onClose: onClickClose,
      containerRef: containerRef,
      backgroundColor: backgroundColor,
      "data-id": "search-modal-autocomplete_index_SearchModalAutocomplete_Overlay"
    })]
  }) : null;
};
export default SearchModalAutocomplete;